var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingRevisitguide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1084.167 -131)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(1084.167 131)",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.667 163a15.5 15.5 0 00-15.5-15.5 15.5 15.5 0 00-15.5 15.5 15.5 15.5 0 0015.5 15.5 15.5 15.5 0 0015.5-15.5zm-15.084-10.375c3.523 0 7.283 2.75 7.283 6.375 0 4.814-5.2 4.888-5.2 6.667v.083a.75.75 0 01-.75.75h-3.5a.75.75 0 01-.75-.75v-.25c0-2.566 1.945-3.592 3.416-4.416 1.261-.707 2.033-1.187 2.033-2.123 0-1.238-1.579-2.06-2.856-2.06-1.7 0-2.465.821-3.581 2.237a.75.75 0 01-1.042.133l-2.169-1.645a.751.751 0 01-.17-1.016 8.1 8.1 0 017.286-3.985zm-.416 15.5a2.878 2.878 0 012.875 2.875 2.878 2.878 0 01-2.875 2.875 2.878 2.878 0 01-2.875-2.875 2.878 2.878 0 012.875-2.875z",
    fill: "#fff"
  }))));
}
export default SvgOnboardingRevisitguide;